import { render } from "./SectionPortfolioDetailFirst.vue?vue&type=template&id=dff54730&scoped=true"
import script from "./SectionPortfolioDetailFirst.vue?vue&type=script&lang=js"
export * from "./SectionPortfolioDetailFirst.vue?vue&type=script&lang=js"

import "./SectionPortfolioDetailFirst.vue?vue&type=style&index=0&id=dff54730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff54730"]])

export default __exports__